module.exports = {
	"name": "CollectorPlugin",
	"version": "2.2.0-alpha.1",
	"description": "",
	"repository": {
		"type": "git",
		"url": "Graylog2/graylog-plugin-collector"
	},
	"scripts": {
		"build": "webpack --bail"
	},
	"keywords": [
		"graylog"
	],
	"author": "Graylog, Inc. <hello@graylog.com>",
	"license": "GPL-3.0",
	"dependencies": {},
	"devDependencies": {
		"graylog-web-plugin": "file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 372
// module chunks = 0